class InventoryComponent extends HTMLElement {
    constructor() {
        super();
        this.shadow = this.attachShadow({ mode: 'open' });
        this.product = this.getAttribute('sku');
    }

    connectedCallback() {
        this.render();
    }


    estilos = `
        <style>
            :host {
                --primary-color: #404b5a;
                --fuente-principal: var(--main-font), sans-serif;
                --secondary-color: #939393;
                color: var(--primary-color);
                background: #555;
            }
            .container-inventory {
                position: fixed;
                z-index: 9999;
                box-sizing: border-box;
                left: 0px;
                top: 0px;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 8px;
                background-color: rgba(0, 0, 0, 0.5);
            }
            #inventory-popup {
                opacity: 0;
                display: none;
            }
            #inventory-popup .title-inventory {
                font-size:14px;
                font-weight: bold;
                line-height: 20px;
                color: var(--primary-color);
                text-align: left;
                display: block;
                width: 100%;
                height: 72px;
                font-family: var(--fuente-principal);
                background-color: #F6F6F6;
                padding: 16px 14px;
                box-sizing: border-box;
            }
            #inventory-popup .subtitle-inventory {
                font-size: 14px;
                color: var(--secondary-color);
                text-align: left;
                display: block;
                width: 100%;
                margin-left: 14px;
                margin-bottom: 10px;
                font-family: var(--fuente-principal);
            }
            #inventory-popup.show {
                position: fixed;
                width: 362px;
                max-height: 400px;
                background-color: #fff;
                border-radius: 4px;
                transform: translateX(-50%) translateY(50%);
                bottom: 50%;
                left: 50%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                gap: 15px;
                opacity: 1;
                animation: show .5s ease;
                overflow-x: hidden;
                z-index: 9999!important;
                @media (max-width: 365px) {
                    width: 95%;
                    height:400px;
                    max-height: 400px;
                    max-width: 100%;
                    gap: 4px;
                }
            }
            #inventory-popup .item-inventory {
                width: 100%;
                box-sizing: border-box;
                font-size: 14px;
                font-family: var(--fuente-principal);
                font-weight: 500;
                margin-top: 10px; 
            }
            
            #inventory-popup .item-inventory p {
                text-align: left;
                border-bottom: 1px solid #F0F0F0;
                margin: 0;
                padding: 2px 0px 8px 14px;
            }
            
            #inventory-popup .item-inventory .title-sucursal {
                display: flex;
                align-items: center;
                column-gap: 8px;
                padding: 4px 0px 8px 14px; 
            }
            
            #inventory-popup .item-inventory .title-sucursal img {
                width: 18px;
                height: 15px;
            }
            
            #inventory-popup .item-inventory .title-sucursal { 
                font-size: 14px;
                font-weight: bold;
                color: var(--primary-color);
                padding: 2px 0px 8px 14px;
                line-height: 0px;
            }
            
            #inventory-popup img {
                width: 40px;
            }
            
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
            
            @keyframes show {
                0% { opacity: 0; }
                100% { opacity: 1; }
            }
            
            #inventory-popup > img { 
                animation: spin 1s linear infinite;
            }
            
            .close-popup {
                position: absolute;
                top: 8px;
                right: 8px;
                border: none;
                cursor: pointer;
                font-size: 16px;
                font-weight: bold;
                color: #000;
                background-color: transparent;
                padding: 0px;
            }
            
            .close-popup img {
                max-width: 15px;
                pointer-events: none;
            }
            
            .skeleton {
                width: 100%;
                height: 40px;
                background-color: rgba(0, 0, 0, 0.1);
                border-radius: 8px;
                animation: skeleton 0.5s infinite; 
                margin:2px 10px;
            }
            
            @keyframes skeleton {
                0% { background-color: #D6D6D6; }
                50% { background-color: #E6E6E6; }
                100% { background-color: #D6D6D6; }
            }
            
            img {
               opacity: 0.7;
            }
            
            #contenedor-items-inventory {
                width: 100%;
                height: 330px;
                box-sizing: border-box;
                padding: 0px 0px;
                display: flex;
                flex-direction: column;
                overflow-y: auto;
                margin-right: 10px;
            }
            
            #contenedor-items-inventory::-webkit-scrollbar {
                width: 8px;
            }
            #contenedor-items-inventory::-webkit-scrollbar-thumb {
                background-color: #404B5A;
                border-radius: 6px;
            }
            #contenedor-items-inventory::-webkit-scrollbar-track {
                background-color: #CED4DA;
                border-radius: 6px;
            }
            
            .contactarAsesorElement {
                display: grid;
                grid-template-columns: 1fr 1fr;
                background: #f4f4f4;
                align-items: center;
                padding: 4px 10px;
            }
            
            .contactarAsesorElement p {
                text-align: left;
                font-size: 14px;
            }
            
            .contactarAsesorElement a {
                background: #f4f4f4;
                display: flex;
                align-items: center;
                font-size: 14px;
                font-weight: bold;
                color: #404b5a;
                text-decoration: none;
                border: solid 1px #404b5a;
                border-radius: 30px;
                width: 80%;
                justify-self: end;
            }
            
            .contactarAsesorElement a img {
                opacity: 1;
            } 
            .contactarAsesorElement a span {
                width: 100%;
                text-align: center;
            } 


            
        </style>
    `;

    async showElements(){
        //htmls globales
        let htmlParaContactarAsesor = `
        <div class="contactarAsesorElement">
            <p> <b>¿Tienes dudas?</b> Chatea con un asesor experto</p>
            <a target="_blank" href="https://wa.me/50766779749/?text=Quiero%20chatear%20con%20un%20asesor%20experto%20https://www.jamar.com.pa/products/${productInFichaObjetcJson.variants[0].sku}">
                <img src="https://cdn.shopify.com/s/files/1/0516/5478/7271/files/chat-whatsapp-icon.svg?v=1683210692" alt="Boton cerrar">
                <span>Ir al chat</span>
            </a>
        </div>
        `;
        var inventoryPopup = this.shadow.querySelector('#inventory-popup');

        inventoryPopup.classList.add('show');
        inventoryPopup.innerHTML = `
            <div class="skeleton"></div>
            <div class="skeleton"></div>
            <div class="skeleton"></div>
            <div class="skeleton"></div>
            <div class="skeleton"></div>
            <div class="skeleton"></div>
            <div class="skeleton"></div>
        `;

        // Peticiones de red a la API
        let productSKU = productInFichaObjetcJson.variants[0].sku;
        let dataFromService = await fetch(`https://prd.appsjamar.com/appventas/inventario/v1/JP/${productSKU}/cendis`);
        let {data} = await dataFromService.json();
        inventoryPopup.innerHTML = '';

        // texto de los titulos dentro del contenedor de disponibilidad
        inventoryPopup.innerHTML += 
        `
            <button class="close-popup" id="closePopup">
                <img src="https://cdn.shopify.com/s/files/1/0516/5478/7271/files/cross.svg?v=1706902994" alt="Boton cerrar">
            </button>
            <span class="title-inventory">Este producto se encuentra disponible <br> en las siguientes tiendas:</span>
            <div id="contenedor-items-inventory" part="scrollbar"></div>
            ${htmlParaContactarAsesor}
            

        `;
        var inventoryPopupContainer = this.shadow.querySelector('#contenedor-items-inventory');

        
        this.shadow.addEventListener('click', (e) => {
            if(e.target.id === 'closePopup'){
                inventoryPopup.classList.remove('show');
            }
        }
        );

        let reemplazarBodega = '';
        const datosAjustados = await ajustarCantidades(data);
        datosAjustados.forEach(element => {
            //replace of the words in the service
            console.log(element)
            reemplazarBodega  = element.DESCRIPCION_BODEGA.replace('BODEGA', '').replace('JAMAR', '').replace('CENDIS WMS PANAMA', 'SITIO WEB').replace('PANAMA VIA ESPANA', 'VIA ESPAÑA');

            //validar unidad o unidades
            if (element.DISPONIBLE == 1) {
                element.DISPONIBLE = element.DISPONIBLE + ' unidad disponible.';
            } else if (element.DISPONIBLE > 1) {
                element.DISPONIBLE = element.DISPONIBLE + ' unidades disponibles.';
            } else {}
            
            inventoryPopupContainer.innerHTML += `
                <div class="item-inventory"> 
                    <div class="title-sucursal">  
                    <img src="https://cdn.shopify.com/s/files/1/0516/5478/7271/files/Store.svg" alt="">
                        ${ reemplazarBodega }
                    </div>
                    <p>${element.DISPONIBLE}</p>
                 </div>
            `;
            
        });
    }
    
    render() {
        this.shadow.innerHTML = this.estilos;
        const containerInventory = document.createElement('div');
        containerInventory.classList.add('container-inventory');
        // containerInventory.innerHTML = svgIconLoading;
        containerInventory.innerHTML = `
            <div id="inventory-popup"></div>
        `;

        this.shadow.appendChild(containerInventory);
        this.showElements();
        //add lister to clic event autoremove element from dom or clic in the global container
        this.shadow.addEventListener('click', (e) => {
            if (e.target.id === 'closePopup') {
                this.remove();
            }
        });
    }
}

customElements.define('inventory-component', InventoryComponent);

document.addEventListener("click", (e) => {
    let productSKU = productInFichaObjetcJson.variants[0].sku;
    if (e.target.classList.contains('buttonFetchInventory')) {
        var componenteInventario = document.createElement('inventory-component');
        componenteInventario.setAttribute('sku', productSKU.toString());
        document.body.appendChild(componenteInventario);
    }
}
);


//funcion para validar 
function ajustarCantidades(data) {
    let sumaTotal = 0;
    let bodega82Cantidad = 0;

    // Verificar si existe la bodega "82"
    const bodega82 = data.find(item => item.BODEGA === "82");
    if (!bodega82) {
        data =  data;
    }

    //borrar del array la bodega F2 si existe
    let index = data.findIndex(item => item.BODEGA === "F2");   
    if (index > -1) {
        data.splice(index, 1);
    }


    // Calcular suma total y cantidad de la bodega "82"
    for (const item of data) {
        sumaTotal += item.DISPONIBLE;
        if (item.BODEGA === "82") {
            bodega82Cantidad = item.DISPONIBLE;
        }
    }

    // Ajustar la cantidad de la bodega "82"
    // para que refleje la suma total
    try {
        bodega82.DISPONIBLE = sumaTotal ? bodega82Cantidad : 0;
    } catch (error) {
        console.error('Error adjusting bodega82 quantity:', error);
    }

    // Ajustar las cantidades de las demás bodegas
    // para reflejar la suma total
    for (const item of data) {
        if (item.BODEGA !== "82") {
            item.DISPONIBLE;
        }
    }

    // Ordenar el array para que la bodega "82" esté siempre en la primera posición
    data.sort((a, b) => {
        if (a.BODEGA === "82") return -1;
        if (b.BODEGA === "82") return 1;
        return 0;
    });   

    return data;
}
